import { render, staticRenderFns } from "./SelfSignupSuccess.vue?vue&type=template&id=72e2c754&scoped=true&"
import script from "./SelfSignupSuccess.vue?vue&type=script&lang=js&"
export * from "./SelfSignupSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SelfSignupSuccess.vue?vue&type=style&index=0&id=72e2c754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2c754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
